import { AppRoutes } from 'consts/routesPath';
import querystring from 'query-string';

/** E.g:
 * [
 *  {
 *    label: 'City',
 *    value: 'city'
 *  }
 * ]
 * =>
 * key = 'value', value = 'label'
 * {
 *  city: City
 * }
 *
 *
 */
export const convertArrayToObject = (list, key, value) => {
  return list.reduce((obj, ele) => {
    obj[ele[key]] = ele[value];
    return obj;
  }, {});
};

/**
 * to format from {
 *  param1: value1,
 *  param2: value2
 * } -> param1=value1&param2=value2
 * */

export const stringifyUrlByParam = (list, key, value) => {
  const stringQuery = list.reduce((string, el, index) => {
    if (el[key]) {
      string += querystring.stringify({ [el[key]]: el[value] }) + '&';
    }

    if (index === 0) {
      string = '?' + string;
    }

    return string;
  }, '');
  return stringQuery.slice(0, stringQuery.length - 1);
};

export const splitUrlAndParams = (paramUrl) => {
  const { url, query } = querystring.parseUrl(paramUrl);
  return { url, query };
};

export const queryToArray = (query) => {
  let arr = [];
  if (typeof query === 'object') {
    for (let q of Object.entries(query)) {
      let newObj = {};

      /** use for case query have duplicate param
       * E.g: url?param1=valueParam&param1=valueParam
       */
      if (typeof q[1] === 'object') {
        q[1].forEach((val) => {
          newObj = {
            param: q[0],
            value: val,
          };
          arr = [...arr, newObj];
        });
      } else {
        newObj = {
          param: q[0],
          value: q[1],
        };
        arr = [...arr, newObj];
      }
    }
  }

  return arr;
};

export const splitObjectKeyFromUrl = (param) => {
  return querystring.parse(param || '');
};

export const checkRoute = (path = '') => {
  const arrayChildRoutes = Object.values(AppRoutes || {}).filter((route) => {
    return typeof route === 'string' && route.includes('/:');
  });
  let isChildRoute = false;
  arrayChildRoutes.forEach((eachRoute) => {
    const tempEachRoute = eachRoute.replace(/:[a-zA-Z0-9]*/gm, '[a-zA-Z0-9]*');
    const checking = new RegExp(tempEachRoute);
    isChildRoute = checking.test(path);
  });

  return {
    isChildRoute,
  };
};

export const normalizeFiltersForQuery = (values) => {
  const result = {};
  Object.keys(values || {}).forEach((key) => {
    const val = values[key];
    if (val === undefined || val === null) return;
    if (typeof val === 'string' && val.trim() === '') return;
    if (Array.isArray(val)) {
      const mapped = val
        .map((item) => (typeof item === 'object' && item?.value !== undefined ? item.value : item))
        .filter((v) => v !== undefined && v !== null && `${v}`.trim() !== '');
      if (mapped.length) result[key] = mapped; // keep as array for repeated key serialization
      return;
    }
    result[key] = val;
  });

  return result;
};

/**
 * Build query string with repeated keys for array values.
 * Encodes values, keeps '&' and '=' separators unencoded.
 */
export const serializeFiltersToSearch = (values) => {
  const query = normalizeFiltersForQuery(values);
  const encode = (v) => encodeURIComponent(String(v));
  const segments = [];

  Object.keys(query || {}).forEach((paramName) => {
    const value = query[paramName];
    if (value === undefined || value === null) return;
    if (typeof value === 'string') {
      if (value.trim() === '') return;
      segments.push(`${paramName}=${encode(value)}`);
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((element) => {
        if (element === undefined || element === null) return;
        const elementValue =
          typeof element === 'object' && element?.value !== undefined ? element.value : element;
        if (`${elementValue}`.trim() === '') return;
        segments.push(`${paramName}=${encode(elementValue)}`);
      });
      return;
    }
    segments.push(`${paramName}=${encode(value)}`);
  });

  return segments.join('&');
};
